<template>
	<!--div class="col-xl-3 col-md-4 col-sm-6 pl-1"-->
	<div class="Grouping-wrapper col-xs-6 mb-4">
		<div class="ReSearchObjGrouping">
			<card class="groupCard pt-2 h-100">
				<div class="groupTopBlock" >
					<div class="groupPhoto"  @click="showGroupFloor()">
						<img v-if="objData.app_image != ''" :src="`/DATA/flat_files/${objData.gk_name_tr}/${objData.app_image}`" alt=""> 
						<img v-if="objData.app_image == ''" src="/img/flatsDefault.svg" style="height: 170px;" alt=""> 
					</div>
					<div class="groupFlats" :class="[bIsGroupfloor ? 'groupFlats-hide' : 'groupFlats-show']">
						<p class="text-center pt-2 mb-0" v-if="masFloorGrouping.length==0">Планировки отсутствуют</p>
						<!--a href="" class="groupfloor"><p class="floor">1 эт</p><p class="money">4 035 000 руб</p><p class="m2money">за м² 104 000 руб</p></a-->
						<router-link 
							v-for="objFlat in masFloorGrouping"
							:to="'/data/module/sso/object/flat/'+objFlat.app_id+strDopGet" 
							:key="objFlat.app_id"
							class="groupfloor">								
								<p class="floor">{{objFlat.app_flatfloor}} эт</p>
								<p class="money">{{$GVO.formatAmount(parseFloat(objFlat.app_flatcostwithdiscounts))}}</p>
								<p class="m2money">за м² {{$GVO.formatAmount(parseFloat(objFlat.app_metrecostwithdiscounts))}}</p>
						</router-link>
					</div>
				</div>

				<div class="groupBottBlock">
					<div class="onFloor" @click="showGroupFloor()"><p>{{groupFloorText.text}}</p></div>

					<div class="row">
						<div class="col baseInfo">
							<p><b>ЖК &laquo;{{objData.gk_name}}&raquo;</b></p>
						</div>
						<div class="col baseInfo">
							<p class="text-right">Квартир: {{objData.count_app_id}}</p>
						</div>
					</div>
					<div class="row justify-content-between">
						<p><b>{{objData.app_rooms}}</b></p>
						<p>от {{$GVO.formatAmount(parseFloat(objData.app_flatcostwithdiscounts))}}</p>
					</div>
						<p>Срок сдачи: <span class="mr-2">{{$GVO.convertDateFromMysql(objData.b_endingperiod)}}</span></p>
						<p>Застройщик: <span class="mr-2">&laquo;{{objData.dev_name}}&raquo;</span></p>
					<div class="row objectPass">
						<div  class="objectPass-row blue-dot"><p>{{$GVO.str_replace(',', ' ',objData.app_decoration_list)}}</p></div>	
						<div  class="objectPass-row blue-dot">
							<p v-if="objData.b_mortgage == 1">Ипотека</p>
							<p v-if="objData.b_militarymortgage == 1">Военная ипотека</p>
							<p v-if="objData.b_subsidy == 1">Субсидии</p>
							<p v-if="objData.b_maternitycapital == 1">Материнский капитал</p>
							<p v-if="objData.b_installment == 1">Рассрочка</p>	
						</div>					
						<!--div class="objectPass-row blue-dot"><p>Тип договора (нет данных - Куратор)</p></!--div-->					
					</div>
					<div class="metro">
						<div class="row flex-nowrap ml-0 mr-2 align-items-top">
							<i class="tim-ic ic-metro text-primary mr-1"></i>
							<p>{{$GVO.str_replace(',',', ',objData.metro_name)}},</p>
						</div> 
						<div class="row ml-0 mr-2 align-items-center">
							<i class="metroIc tim-icons icon-user-run text-primary"></i> 
							<p>{{objData.metro_distance}} мин.,</p>									
						</div> 
						<div class="row mx-0 align-items-center">
							<i class="metroIc tim-icons icon-bus-front-12 text-primary"></i> 
							<p>{{objData.metro_distance_transport}} мин.</p>									
						</div> 								
					</div>
					<div class="objectAddress"><p>{{objData.dis_name}}, {{objData.gk_street}}</p></div>  <!--тут же должен быть номер дома, но его нигде не нашли-->
				</div>
				 <!--pre>{{objData}}</pre-->
			</card>
		   
		</div>
	</div>
</template>

<script>

	export default {
		name: 'ReSearchObjGrouping',
		components: {            			
		},
		props: {
			objData: Object,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				bIsGroupfloor: true,
				groupFloorText: {
					text: "Показать по этажам"
				},
				masFloorGrouping:[],
			}
		},
		computed: {
			strDopGet: function(){
				const objGet = this.$GVO.GetAllGet();
				let strGetRet = '';
				if(typeof objGet.task_id != 'undefined' && typeof objGet.taskend_id != 'undefined' && typeof objGet.client_id != 'undefined'){
					strGetRet = `?task_id=${objGet.task_id}&taskend_id=${objGet.taskend_id}&client_id=${objGet.client_id}`;
				}
				return strGetRet;
			},
		},
		methods: {
			showGroupFloor() {
				this.bIsGroupfloor = !this.bIsGroupfloor;
				if (this.bIsGroupfloor) {
					this.groupFloorText.text = "Показать по этажам";
				} else {
					this.groupFloorText.text = "Скрыть";
					if(this.masFloorGrouping.length == 0){
						this.$GVO.ApiCall('GET_FLAT_GROUPBY_PLAN',{obj:'NovoObj',flt:{dev_name_tr: this.objData.dev_name_tr,gk_name_tr: this.objData.gk_name_tr,app_image: this.objData.app_image, gp_app_id: this.objData.gp_app_id}})
						.then((objApi) => {
							if(objApi.success === true){
								if(objApi.data.length > 0){
									this.masFloorGrouping = objApi.data;
								}
							}
						}).catch(errorObjApi => {this.masFloorGrouping = []; console.error(errorObjApi);});
					}
				}
			},

		},
	}
</script>
<style scoped>
.ReSearchObjGrouping {width: 300px;}
.Grouping-wrapper  {display: flex; flex-wrap: wrap; margin-right: 30px;}
.ReSearchObjGrouping >>> .card-body {padding: 0px 5px 10px 5px;}
.ReSearchObjGrouping >>> .row {margin: 0px 0px 5px 0px;}
.ReSearchObjGrouping:not(:last-child) {margin-right: 15px;}
.groupCard {border: 1px solid #9e77f3; box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important; padding: 0px 0px 0px 10px; height: -webkit-fill-available;}
.groupBottBlock {padding:0px 10px 0px 0px;}
.groupTopBlock {border-bottom: 1px solid #01b0e0; padding: 20px 0px; position: relative;overflow-y: scroll;}
.groupBottBlock {padding-top: 10px;}
.baseInfo {padding: 0px;}
.groupPhoto {display: flex; width: 100%; height: 200px; cursor: pointer;}
.groupPhoto img {width: 100%; height: 100%; margin: 0 auto; object-fit: contain;}
.onFloor {text-align: center; cursor: pointer; margin-bottom: 8px; padding-top: 5px;}
.onFloor p {color: #01b0e0;}
.groupFlats {z-index: 2; position: absolute; top: 20px; left: 0px; background: rgb(39, 41, 61, 0.9); padding: 5px 5px 10px 8px; width: 100%;}
.white-content .card:not(.card-white) .groupFlats {background: rgb(255, 255, 255, 0.95);}
.groupFlats-show {display: block;} 
.groupFlats-hide {display: none;} 
.groupfloor p:not(:last-child) {margin-right: 10px;}
.groupfloor {display: flex; flex-wrap: wrap; border-bottom: 1px solid rgb(1, 176, 224, 0.4);;}
.groupfloor p {color: unset;}
.metro {display: flex; align-items: center; flex-wrap: wrap;}
.metroIc {margin-right: 7px;}
.metroIc {margin-bottom: 8px;}
.objectPass {display: flex; justify-content: flex-start; flex-wrap: wrap;}
.objectPass  p:not(:first-child) {margin-left: 10px; padding-left: 5px;position: relative;}
.objectPass p:not(:first-child)::before {
	content: '';
	position: absolute;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #ccc;
	left: -3px;
	top: 40%;
} 
.objectPass .blue-dot {margin-right: 7px; padding-right: 12px; position: relative;}
.objectPass .blue-dot:not(:last-child)::after {
	content: '';
	position: absolute;
	margin-left: 7px;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #01b0e0;
	top: 30%;
	right: 2px;
}
.objectPass-row {display: flex; flex-wrap: wrap;}
.objectDev {display: flex; justify-content: space-between; padding-right: 0px;}
.ReSearchObjGrouping .money, .ReSearchObjGrouping .floor {margin-bottom: 2px;}


/*===media===============================*/
@media (max-width: 768px) {	
	.ReSearchObjGrouping {width: 100%; margin-bottom: 15px;}
	.Grouping-wrapper {flex-direction: column; width: 100%; margin-right: 0px;}
	.groupCard {padding:0px 0px 7px;}
	.groupfloor {font-size: 12px;}
	.groupBottBlock {padding: 0px 10px 0px 10px;}
}


</style>
